<script>
	// Stores
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	import BetTypeStore from '@/Stores/Racing/BetTypeStore.js';
	import ProductStore from '@/Stores/Racing/ProductStore.js';
	import RaceBetTypeStore from '@/Stores/Racing/RaceBetTypeStore.js';
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import Loading from '@/Components/Loading.svelte';
	// Partials
	import EditProductBetTypes from '@/Partials/Racing/ProductBetType/_EditProductBetTypes.svelte';
	import UpdateClassification from '@/Partials/Racing/Race/_UpdateClassification.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let open = false;
	export let meeting = undefined;
	export let race = undefined;

	$: title = `Manage Race ${race && race.race_number} at ${meeting && meeting.name} - ${
		meeting && meeting.race_type.name
	}`;
	$: loading = !loaded && open && getRaceWithBetTypes();
	// reset loaded to false when we close
	$: open === false ? (loaded = false) : null;

	let sending = false;
	let loaded = false;

	function getRaceWithBetTypes() {
		RaceStore.getRaceWithBetTypes(race.id, meeting.id).then(() => (loaded = true));
		ClassificationStore.getClassifications();
		if (race.classification) ClassificationStore.getClassificationWithBetTypes(race.classification.id);
	}

	function onClickSave(event) {
		sending = true;
		RaceBetTypeStore.updateRaceBetTypes(race.id, {
			race_bet_types: event.detail
		})
			.then(() => {
				notify({
					type: 'success',
					title: `Race ${race.race_number}`,
					message: 'Race Bet Types updated',
					timeout: 3
				});
			})
			.finally(() => {
				sending = false;
			});
	}
</script>

{#await loading}
	<Loading />
{:then}
	{#if open && meeting}
		<Modal on:close={() => (open = false)} className="mx-2 md:w-2/3 md:mx-auto">
			<div class="py-2 font-semibold text-center uppercase" slot="header">
				{title}
			</div>
			<div class="flex flex-col p-2">
				<UpdateClassification {race} />
				<div class="my-4 border-b" />
				<div class="pt-2 font-semibold text-center uppercase">Override Bet Types & Products</div>
				<EditProductBetTypes
					products={$ProductStore}
					betTypes={$BetTypeStore}
					selectedBetTypes={$RaceBetTypeStore}
					showClassificationDefaults={false}
					{sending}
					on:clickSave={onClickSave}
				/>
			</div>
		</Modal>
	{/if}
{/await}
